<template>
  <div>
    <p class="mb-2">The contact(s) you are looking for was not found.</p>
    <v-btn
      v-if="showAddButton"
      color="appMain"
      :small="smallButton"
      @click="showModal = true"
    >
      Add Contact
    </v-btn>

    <v-dialog
      v-model="showModal"
      max-width="600"
      content-class="fixed-height-md"
    >
      <contact-create-modal
        @close="showModal = false"
        @created="$emit('created', $event)"
        returnContact
        :search="search"
      />
    </v-dialog>
  </div>
</template>

<script>
import ContactCreateModal from '@/views/contacts/components/ContactCreateModal';

export default {
  name: 'ContactNotFound',
  components: {
    ContactCreateModal,
  },
  props: {
    search: String,
    showAddButton: Boolean,
    smallButton: Boolean,
  },
  data() {
    return {
      showModal: false,
    };
  },
};
</script>
